import React, { useState } from 'react';
import { Button, TextInput, Radio } from '@components';
import { Field, Formik } from 'formik';
import { formatToBRL } from 'brazilian-values';
import { calculadoraExaurimentoSchema } from '@schemas';
import { Collapse } from '@mui/material';
import { TransformacaoBeneficioService } from '../../../common/services/transformacao-beneficio';

const service = new TransformacaoBeneficioService();

export const StepsTBSimulacao = ({
  setModalIsOpen,
  setInfoModalIsOpen,
  data,
  setModalTableData,
  setMsgErro,
  token,
  visibleAporte,
  visibleParcelaAdicional,
}) => {
  const [steps, setSteps] = useState({
    one: true,
    two: false,
    three: false,
  });

  const [viewSteps, setViewSteps] = useState({
    one: true,
    two: false,
    three: false,
  });
  const [simulationData, setSimulationData] = useState({});
  const [resultSimulation, setResultSimulation] = useState({});
  const [loading, setLoading] = useState(false);
  const [valoresIndice, setValorIndice] = useState({});

  function handleSteps(value) {
    const changedValues = {
      ...!steps,
      [value]: !steps[value],
    };

    const changedViewSteps = {
      ...viewSteps,
      [value]: true,
    };

    setSteps(changedValues);
    setViewSteps(changedViewSteps);
  }

  async function handleSimulateValues(values) {
    const valorAporte = Number(values.valorAporte || 0);
    const saldoAposAporte = data.reserva + valorAporte;
    const percentualRendaMensal = Number(values.percentualRendaMensal || 0);
    const valorRendaMensal = saldoAposAporte * (percentualRendaMensal / 100);

    const requestParams = {
      matricula: data.matricula,
      plano: data.plano,
      dataNascimento: data.dataNascimento.split('/').reverse().join('-'),
      parcelaAdicional: values.opcaoParcelaAdicional === 'S' ? 1 : 0,
      saldo: saldoAposAporte,
      saqueVista: 0,
      inflacao: 4,
      renda: valorRendaMensal,
      validarBeneficio: 1,
    };

    setSimulationData({
      ...requestParams,
      valorAporte,
      saldoAposAporte,
      percentualRendaMensal,
      labelParcelaAdicional:
        values.opcaoParcelaAdicional === 'S' ? 'Sim' : 'Não',
    });

    service.getCalculoExaurimento(requestParams).then((res) => {
      const tableData = [
        {
          title: 'Primeira data com percentual igual a 1%',
          value: res.dataPercentualMaximo
            ? `em ${res.dataPercentualMaximo}`
            : 'Não haverá',
          description: 'perda do poder aquisitivo',
        },
        {
          title: 'Quando vai ocorrer o exaurimento do fundo?',
          value: `em ${res.tempoExaurimento} anos`,
          description: `isso vai acontecer em ${res.dataExaurimento}`,
        },
        {
          title: 'Qual será sua idade?',
          value: res.idadeExaurimento,
          description: '',
        },
        {
          title: 'Qual será o saldo na data de exaurimento?',
          value: formatToBRL(res.saldoExaurimento),
          description: '',
        },
        {
          title: 'Em qual valor estará meu benefício?',
          value: formatToBRL(res.beneficioExaurimento),
          description: 'poder aquisitivo',
        },
      ];

      if (visibleParcelaAdicional) {
        tableData.push({
          title: 'Opção por parcela adicional?',
          value: values.opcaoParcelaAdicional === 'S' ? 'Sim' : 'Não',
          description: 'paga em dezembro',
        });
      }

      setMsgErro(res.msgConsistencia);
      setModalIsOpen(!!res.msgConsistencia);

      setResultSimulation(tableData);
      setModalTableData(res.ListaGrafico);
      setValorIndice(res.valoresIndice);

      if (!res.msgConsistencia) {
        handleSteps('three');
      }
    });
  }

  function handleOpenExtrato() {
    const requestParams = {
      matricula: data.matricula,
      nome: data.nome,
      dataNascimento: data.dataNascimento.split('/').reverse().join('-'),
      parcelaAdicional: simulationData.parcelaAdicional,
      saldo: simulationData.saldoAposAporte,
      saqueVista: 0,
      inflacao: 4,
      renda: simulationData.renda,
      plano: data.plano,
    };
    setLoading(true);
    service
      .getPdfTabelaExaurimento(requestParams, token)
      .then((res) => {
        const a = document.createElement('a');
        a.href = `data:application/pdf;base64,${res}`;
        a.download = `Tabela de Exaurimento - ${requestParams.matricula}.pdf`;
        a.click();
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <>
      <div id="step-01" className={`tbstep ${!steps.one && 'tbhide'}`}>
        <div className="tbHeaderTitle">
          <span
            className={`tbstepNumber ${steps.one && 'tbstepNumber-focused'} ${
              viewSteps.one && !steps.one && 'tbstepNumber-filled'
            }`}
          >
            1
          </span>

          <div className="tbstepTitle">
            <h2>
              <strong>Benefício atual</strong>
            </h2>
            {steps.one && (
              <p>Confira suas informações detalhadas do seu benefício hoje.</p>
            )}
          </div>
        </div>

        <div className="tbstepContent">
          {viewSteps.one && !steps.one && (
            <button className="tbviewStep" onClick={() => handleSteps('one')}>
              Visualizar
            </button>
          )}

          {steps.one && (
            <>
              <Formik
                initialValues={{
                  ...data,
                  reserva: formatToBRL(data.reserva),
                  beneficioAtual: formatToBRL(
                    data.beneficioAtual?.replace(',', '.')
                  ),
                  percentualAtual: `${data.percentualAtual}%`,
                }}
              >
                {({ handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <Field
                      disabled
                      name="idade"
                      className="mb-3"
                      component={TextInput}
                      label="Idade:"
                    />
                    <Field
                      disabled
                      name="reserva"
                      className="mb-3"
                      component={TextInput}
                      label="Saldo remanescente:"
                    />
                    <Field
                      disabled
                      name="percentualAtual"
                      className="mb-3"
                      component={TextInput}
                      label="Percentual de retirada atual:"
                    />
                    <Field
                      disabled
                      name="beneficioAtual"
                      className="mb-3"
                      component={TextInput}
                      label="Benefício atual:"
                    />
                  </form>
                )}
              </Formik>

              <div className="tbbutton">
                <Button className="max-180" onClick={() => handleSteps('two')}>
                  Continuar
                </Button>
              </div>
            </>
          )}
        </div>
      </div>

      <div id="step-02" className={`tbstep ${!steps.two && 'tbhide'}`}>
        <div className="tbHeaderTitle">
          <span
            className={`tbstepNumber ${steps.two && 'tbstepNumber-focused'} ${
              viewSteps.two && !steps.two && 'tbstepNumber-filled'
            }`}
          >
            2
          </span>

          <div className="tbstepTitle">
            <h2>
              <strong>Simulador</strong>
            </h2>
            {steps.two && (
              <p>
                Informe os dados solicitados e confira a evolução do seu saldo.
              </p>
            )}
          </div>
        </div>

        <div className="tbstepContent">
          {viewSteps.two && !steps.two && (
            <button className="tbviewStep" onClick={() => handleSteps('two')}>
              Editar
            </button>
          )}

          {steps.two && (
            <Formik
              initialValues={{
                opcaoAporte: simulationData.valorAporte > 0 ? 'S' : '',
                valorAporte: simulationData.valorAporte || '',
                saldoPosAporte: simulationData.saldoPosAporte || '',
                percentualRendaMensal:
                  simulationData.percentualRendaMensal || '',
                valorRendaMensal: simulationData.renda || '',
                opcaoParcelaAdicional:
                  simulationData.parcelaAdicional === 1 ? 'S' : '',
              }}
              validationSchema={calculadoraExaurimentoSchema(
                data.percentualMax,
                visibleAporte,
                visibleParcelaAdicional
              )}
              onSubmit={(values) => handleSimulateValues(values)}
            >
              {({ handleSubmit, values, isValid, setFieldValue }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    {visibleAporte && (
                      <>
                        <div className="tboptionParcelaAVista">
                          <p>Você pretende fazer um aporte?</p>
                          <div className="tbRadioOptions">
                            <Field
                              name="opcaoAporte"
                              value="S"
                              color="orange"
                              type="radio"
                              label="Sim"
                              component={Radio}
                              onChange={() => {
                                setFieldValue('valorAporte', '', true);
                              }}
                            />
                            <Field
                              name="opcaoAporte"
                              value="N"
                              color="orange"
                              type="radio"
                              label="Não"
                              component={Radio}
                              onChange={() => {
                                setFieldValue('valorAporte', '', false);
                              }}
                            />
                          </div>
                        </div>
                        <Collapse in={values.opcaoAporte === 'S'}>
                          <>
                            <Field
                              name="valorAporte"
                              component={TextInput}
                              type="number"
                              label="Qual o valor do aporte?"
                              value={
                                values.opcaoAporte !== 'S'
                                  ? ''
                                  : values.valorAporte
                              }
                            />
                            <Field
                              disabled
                              name="saldoPosAporte"
                              className="mb-3"
                              component={TextInput}
                              label="Novo saldo (após o aporte):"
                              value={formatToBRL(
                                Number(data.reserva) +
                                  Number(values.valorAporte)
                              )}
                            />
                          </>
                        </Collapse>
                      </>
                    )}

                    <Field
                      type="number"
                      name="percentualRendaMensal"
                      className="mb-3"
                      component={TextInput}
                      label={`Qual percentual de renda deseja simular? (entre 0.1% e ${data.percentualMax}%)`}
                    />
                    <Field
                      disabled
                      name="valorRendaMensal"
                      className="mb-3"
                      component={TextInput}
                      label="Benefício simulado:"
                      value={formatToBRL(
                        (data.reserva + values.valorAporte) *
                          (values.percentualRendaMensal / 100) || 0
                      )}
                    />
                    {visibleParcelaAdicional && (
                      <div className="tboptionParcelaAVista">
                        <p>
                          Você pretende receber parcela adicional? (Pagamento
                          extra em dezembro)
                        </p>
                        <div className="tbRadioOptions">
                          <Field
                            name="opcaoParcelaAdicional"
                            value="S"
                            color="orange"
                            type="radio"
                            label="Sim"
                            component={Radio}
                          />
                          <Field
                            name="opcaoParcelaAdicional"
                            value="N"
                            color="orange"
                            type="radio"
                            label="Não"
                            component={Radio}
                          />
                        </div>
                      </div>
                    )}

                    <div className="tbbutton">
                      <Button
                        type="submit"
                        className="max-180"
                        disabled={!isValid}
                      >
                        Simular
                      </Button>
                      {}
                    </div>
                  </form>
                );
              }}
            </Formik>
          )}
        </div>
      </div>

      <div id="step-03" className={`tbstep ${!steps.three && 'tbhide'}`}>
        <div className="tbHeaderTitle">
          <span
            className={`tbstepNumber ${steps.three && 'tbstepNumber-focused'} ${
              viewSteps.three && !steps.three && 'tbstepNumber-filled'
            }`}
          >
            3
          </span>

          <div className="tbstepTitle">
            <h2>
              <strong>Resultado</strong>
            </h2>
            {steps.three && (
              <>
                <p>Confira o resultado da simulação.</p>
                <p>
                  Lembre-se: caso queira realizar a troca de percentual de
                  retirada mensal ou qualquer outra alteração, você precisa
                  acessar o respectivo serviço na página inicial da sua área do
                  participante.
                </p>
              </>
            )}
          </div>
        </div>

        <div className="tbstepContent">
          {viewSteps.three && !steps.three && (
            <button className="tbviewStep" onClick={() => handleSteps('three')}>
              Visualizar
            </button>
          )}
          {steps.three && (
            <>
              <div className="tbOptionDescription">
                <div className="tbOptionLabel">
                  <p>Valores desejados</p>
                </div>
                <span>Renda temporária em valor variável</span>
                <div className="tbSimulationValues">
                  <div className="tbSimulationValuesWrapper">
                    <p>Saldo atual:</p>
                    <p className="values">{formatToBRL(data.reserva)}</p>
                  </div>
                  {!!simulationData.valorAporte && (
                    <>
                      <div className="tbSimulationValuesWrapper">
                        <p>Valor aportado:</p>
                        <p className="values">
                          {formatToBRL(simulationData.valorAporte)}
                        </p>
                      </div>

                      <div className="tbSimulationValuesWrapper">
                        <p>Saldo após o aporte:</p>
                        <p className="values">
                          {formatToBRL(simulationData.saldo)}
                        </p>
                      </div>
                    </>
                  )}
                  <div className="tbSimulationValuesWrapper">
                    <p>Benefício mensal:</p>
                    <p className="values">
                      {formatToBRL(simulationData.renda)}
                    </p>
                  </div>
                  <div className="tbSimulationValuesWrapper">
                    <p>Percentual do benefício mensal:</p>
                    <p className="values">
                      {simulationData.percentualRendaMensal}%
                    </p>
                  </div>
                </div>

                <div className="tbrow" />
                <span>
                  Os valores disponibilizados aqui são somente uma projeção.
                  Portanto, podem ocorrer diferenças entre o resultado da
                  simulação e o valor real no decorrer da evolução do saldo de
                  conta de aposentadoria.
                </span>
              </div>

              <div className="tbBoxContainer">
                {resultSimulation.map((box) => (
                  <div className="tbBoxWrapper" key={box.title}>
                    <p>{box.title}</p>
                    <p>{box.value}</p>
                    <p>{box.description}</p>
                  </div>
                ))}
              </div>

              <div className="tbterms">
                <p className="tbdescription">
                  <b>Considerações e ressalvas da simulação: </b>
                </p>
                <ul>
                  <li className="tbdescription">
                    O valor de benefício simulado se manterá o mesmo enquanto a
                    reserva individual suportar, ainda que seja necessário
                    alterar o percentual de retirada, limitado à faixa de 0.10%
                    a {Number(data.percentualMax).toFixed(2)}%, sobre a reserva.
                  </li>
                  <li className="tbdescription">
                    O exaurimento apresentado é a maior data entre{' '}
                    {valoresIndice.idadeMaxima} anos de idade ou quando o valor
                    do benefício mensal ficar menor que a unidade de referência
                    da Forluz, R$
                    {valoresIndice.upf1}, conforme descrito no Regulamento do
                    Plano.
                  </li>
                  <li className="tbdescription">
                    O saldo e valor do benefício na data do exaurimento
                    correspondem ao valor presente do dinheiro (tempo presente).
                    Ou seja, representa poder aquisitivo/poder de compra nos
                    dias atuais.
                  </li>
                  <li className="tbdescription">
                    A presente simulação, como qualquer projeção
                    econômico-financeira considera uma série de premissas e
                    condições que não garantem a sua realização.
                  </li>
                  <li className="tbdescription">
                    Algumas simplificações e modelagens são necessárias para
                    facilitar o entendimento dos participantes, como atender à
                    vasta gama de participantes em diferentes condições
                    financeiras etárias.
                  </li>
                  <li className="tbdescription">
                    Buscando refletir os mais prováveis cenários condições
                    macroeconômicas esse simulador foi modelado com fluxo
                    corrente (estimativa de retorno de investimentos em{' '}
                    {valoresIndice.retornoRealInvestimento}% ao ano{' '}
                    {valoresIndice.inflacao > 0
                      ? `e inflação estimada de ${valoresIndice.inflacao}% ao ano).`
                      : '). Esta modelagem não possui projeção da inflação durante o período simulado.'}
                  </li>
                  <li className="tbdescription">
                    Já os resultados apresentados são retornados à moeda de
                    hoje, de forma que o participante possa melhor compreender
                    as projeções face ao seu poder de compra e orçamento atuais.
                  </li>
                </ul>
              </div>

              <div className="tbSimulationButtons">
                <Button
                  transparent
                  color="orange"
                  disabled={loading}
                  className="max-100"
                  onClick={() => handleOpenExtrato()}
                >
                  {!loading ? 'Evolução saldo' : 'Carregando...'}
                </Button>
                <Button
                  transparent
                  color="orange"
                  className="max-100"
                  onClick={() => setInfoModalIsOpen(true)}
                >
                  Acessar gráfico detalhado
                </Button>
              </div>
              <Button className="max-100" onClick={() => handleSteps('two')}>
                Realizar nova simulação
              </Button>
            </>
          )}
        </div>
      </div>
    </>
  );
};
